import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { segmentRef } from '../segmentRef';
import { ClientDirectoryRow, CriterionDescriptor, ResolvedSegment } from '../type';

export interface ListCategoryState {
  segments: ResolvedSegment[];
  filterSchema: CriterionDescriptor[];
  isLoading: boolean;
  hasError: boolean;
  directory: ClientDirectoryRow[];
  directoryLoading: boolean;
}

const initialState: ListCategoryState = {
  segments: [],
  filterSchema: [],
  isLoading: false,
  hasError: false,
  directory: [],
  directoryLoading: false,
};

export const { actions, reducer } = createSlice({
  name: 'listCategory',
  initialState,
  reducers: {
    setSegments: (state, action: PayloadAction<ResolvedSegment[]>) => {
      state.segments = action.payload;
      state.hasError = false;
    },
    setFilterSchema: (state, action: PayloadAction<CriterionDescriptor[]>) => {
      state.filterSchema = action.payload;
    },
    setSegmentEnabled: (state, action: PayloadAction<{ ref: string; isEnabled: boolean }>) => {
      state.segments = state.segments.map(segment =>
        segmentRef(segment) === action.payload.ref ? { ...segment, isEnabled: action.payload.isEnabled } : segment,
      );
    },
    setListCategoryLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setListCategoryError: (state, action: PayloadAction<boolean>) => {
      state.hasError = action.payload;
    },
    setClientDirectory: (state, action: PayloadAction<ClientDirectoryRow[]>) => {
      state.directory = action.payload;
    },
    setClientDirectoryLoading: (state, action: PayloadAction<boolean>) => {
      state.directoryLoading = action.payload;
    },
  },
});
